import { gridThemeParse } from './component/grid';
import { xAxisThemeParse } from './component/xAxis';
import { yAxisThemeParse } from './component/yAxis';
import { graphicThemeParse } from './component/graphic';
import { animationThemeParse } from './component/animation';
import { dynamicBarThemeParse } from './series/dynamicBar';
import { treemapThemeParse } from './series/treemap';
import { dvScatterThemeParse } from './series/dvScatter';
import { pcLineThemeParse } from './series/line';
import { pcBarThemeParse } from './series/bar';

// 问财动态条形图、矩形树图、气泡图
export const pcWencaiLight = {
  name: 'pc-wencai-light' as const,
  parsers: [
    // series
    dynamicBarThemeParse,
    treemapThemeParse,
    dvScatterThemeParse,
    // component
    gridThemeParse,
    xAxisThemeParse,
    yAxisThemeParse,
    graphicThemeParse,
    animationThemeParse
  ]
};

export const pcAppLight = {
  name: 'pc-app-light' as const,
  parsers: [
    // series
    pcBarThemeParse,
    pcLineThemeParse,
    dvScatterThemeParse
  ]
};

export const pcAppDark = {
  name: 'pc-app-dark' as const,
  parsers: [
    dynamicBarThemeParse,
    // series
    pcBarThemeParse,
    pcLineThemeParse
  ]
};
